export default "__VITE_ASSET__3iJ1KXt5__"